import { layeredSelection, tileConfigurationKey, validateLayeredSets } from './layeredEngraving'

/** Prices are per set for layered engravings and boxes, per tile otherwise. */
export function buildStudioCartTiles(shapes: any[], getSetSize: (shapeId: string) => number = () => 1) {
  validateLayeredSets(shapes)
  const tiles: Record<string, any> = {}
  for (const shape of shapes) {
    const meta = shape.metadata || shape.attrs?.metadata
    if (!meta?.variant_id) continue
    const layer = layeredSelection(shape)
    const key = tileConfigurationKey(meta)
    const size = layer?.tiles_per_set || getSetSize(meta.shape_id) || 1
    const tile = tiles[key] ??= {
      variant_id: meta.variant_id, product_id: meta.product_id, quantity: 0, cost: 0,
      ...(layer ? { layered_engraving: { ...layer }, shape_label: meta.shape_label } : {}),
      tileCount: 0, size, price: Number(meta.price) || 0,
    }
    tile.tileCount++
  }
  for (const [key, tile] of Object.entries(tiles)) {
    const quantity = Math.ceil(tile.tileCount / tile.size)
    const { tileCount, size, price, ...payload } = tile
    tiles[key] = { ...payload, quantity, cost: quantity * price }
  }
  return tiles
}
